// reportWebVitals — measures Core Web Vitals and reports them via the provided callback.
// getFID was removed in web-vitals v3 (replaced by INP). This file supports v3+.
// Usage: reportWebVitals(console.log) or reportWebVitals(sendToAnalytics)

const reportWebVitals = (onPerfEntry) => {
    if (onPerfEntry && onPerfEntry instanceof Function) {
        import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
            onCLS(onPerfEntry);   // Cumulative Layout Shift
            onFCP(onPerfEntry);   // First Contentful Paint
            onLCP(onPerfEntry);   // Largest Contentful Paint
            onTTFB(onPerfEntry);  // Time to First Byte
            onINP(onPerfEntry);   // Interaction to Next Paint
        });
    }
};

export default reportWebVitals;